import { render, staticRenderFns } from "./PurchasePrincipleForm.vue?vue&type=template&id=522ac2c4&scoped=true"
import script from "./PurchasePrincipleForm.vue?vue&type=script&lang=js"
export * from "./PurchasePrincipleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ac2c4",
  null
  
)

export default component.exports